import Blacklight from '../blacklight'
import $ from 'jquery'
import 'leaflet'
import 'leaflet.markercluster'
import '../blacklight/blacklight-maps-browse'

function initializeMapBrowse() {
  const $map = $('#blacklight-index-map')
  if (!$map.length || $map.hasClass('leaflet-container')) return

  const geojson = $map.data('geojson')
  if (!geojson) return

  $map.blacklight_leaflet_map(typeof geojson === 'string' ? JSON.parse(geojson) : geojson)
}

Blacklight.onLoad(initializeMapBrowse)
initializeMapBrowse()
